// ** Navigation sections imports
import organization from "./organization"
import profile from "./profile"
import application from "./application"
// import instruction from "./instruction"

// ** Merge & Export
export default [...profile, ...organization, ...application]
